module.exports = __webpack_public_path__ + "static/media/ui-ux-graphics@mobile.d43cf4be.svg";